import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
  esp: (
    `
    <p class="mb-1">
      La mondo estas teatro, la homoj estas aktoroj. 
      Tiu penso trovis konfirmon en la sorto de nia granda majstro, eluzanta sian aktoran talenton ne sur teatra podio aŭ en la lumo de kinoaparatoj, sed en la densejo de nia bolanta ĉiutageco. 
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Permesu demandi vin, estimata majstro, kiam vi decidis aktoriĝi?
    </p>

    <p class="mb-3">
      <span class="bold">Aktoro</span>: Tio okazis en la plej frua mia infaneco. 
      Jes, ne volis mi iri al infanĝardeno, kaj tiam la unuan fojon ludis mi fikcian malsanulon. 
      La sukceso estis neimagebla. 
      La sola spektanto – mia panjo – tiom ekkredis al mia ludo, ke ne nur lasis min hejme, sed ankaŭ aĉetis por mi multege da frandaĵoj. 
    </p>


    <p class="mb-1">
      <span class="bold">Raportisto</span>: Kiel aspektis poste via aktora vivo?
    </p>

    <p class="mb-1">
      <span class="bold">Aktoro</span>: Ĉion konsiderante, mi povas diri, ke faris mi sufiĉe multon. 
      Estinte lernanto, speciale por pedagogia kolektivo, mi ludis diligentulon, kaj por geamikoj mi preparis la tipon de gaja, bonanima knabeto – la karaktero, ĝis nun ŝatata de junularo.
    </p>

    <p class="mb-3">
      En la universitato mia krea diapazono signife plivastiĝis: mi ludis romantikeman amanton, ekmastris la komedian rolon de iom diboĉema simplulo. 
      Sed la plej granda mia sukceso rezultiĝis la tipo de modesta, profunde pensanta, inteligenta junulo.
    </p>


    <p class="mb-1">
      <span class="bold">Raportisto</span>: Ĉu okazis sur via krea vojo fiaskoj, malsukcesoj?
    </p>

    <p class="mb-1">
      <span class="bold">Aktoro</span>: Certe, ili ne preterlasis min, same kiel aliujn junajn aktorojn. 
      Sed malsukcesoj mem estas edifaj. 
      Jen, ekzemple, ludis mi ardan Romeon, enamiĝintan al mia samkursanino Ina, la filino de nia dekano. 
      Sed ŝi – imagu nur! – subite edziniĝis al hokeisto.
    </p>

    <p class="mb-3">
      Longe mi suferis pro mia unua fiasko, sed ekde tiam mi eklernis pli severe elekti mian lirikan repertuaron.
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Kiu el la aktoroj de la olda generacio plej influis la disvolviĝon de via talento?
    </p>

    <p class="mb-3">
      <span class="bold">Aktoro</span>: Sendube, s-ro Senĝenov, mia unua estro, nekomparebla pedagogo. 
      La tekniko de lia ludo estis elformigita ankoraŭ en la tempo, kiam fondiĝis la skolo de travivaĵo; kaj ĝis nun tiu tekniko ŝajnas al mi nesuperebla. 
      Kaj kiel brile posedis mia estro sian voĉon! 
      Tiuj momentaj transiroj de kolera monologo antaŭ geoficistoj al delikata lirikeco de telefonaj konversacioj! 
      Tiun skolon mi neniam forgesos.
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Ni ĉiuj konas vin kiel kreinton de la plena galerio de la plej diversaj tipoj. 
      Inter ili troviĝas tiuj malfacilegaj, komplikaj tipoj, kiel vic-fakestro, sindona edzo, zorgema patro, scivolema vojaĝanto, fripona kuntablulo kaj multaj, multaj aliaj. 
      Sed kiu el viaj verkoj estas la plej amata de vi?
    </p>

    <p class="mb-3">
      <span class="bold">Aktoro</span>: Verŝajne, multaj kritikistoj kaj amikoj miaj opinias, ke la plej amata mia rolo estas sekreta amanto de Luma Ŝikina el nia PR-fako. 
      Tamen ili eraras. 
      La plej kara por mi estas la rolo de fidela, severa, tamen ĉiam justa edzo en la eterna dramo de familia vivo.
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Kion vi opinias pri la problemoj de aktora majstreco?
    </p>

    <p class="mb-1">
      <span class="bold">Aktoro</span>: Laŭ mi, plej gravas en la aktora majstreco tiu profunda kompreno de la sentoj de publiko. 
      Jen la freŝa ekzemplo.

    </p>

    <p class="mb-3">
      Dum multaj jaroj mi sukcese plenumis la rolon de vic-fakestro. 
      Sed antaŭnelonge subite alvenis kontrola komisiono, komencis studadi dokumentojn, interparoladi kun miaj subuloj. 
      La publiko ekscitiĝis, mi rimarkis foreston de kontakto… 
      Nu, estis mi devigita pliriĉigi mian paletron per novaj farboj: bonkoreco, zorgemo, eĉ ioma sentimentaleco. 
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Kio helpas al vi dum preparo al via rolo?
    </p>

    <p class="mb-1">
      <span class="bold">Aktoro</span>: Antaŭ ĉio – la kontakto kun kompanianoj. 
      Ideala kunludantino por mi ĉiam estas mia edzino Luda. 
      Ŝi tiel delikate elmontras karakteron de amanta kaj ĵaluza amikino de mia vivo! 
      Iam sufiĉas nur malgranda aludo: ekzemple, frakasi teleron aŭ frapegi per la pordo – kaj la familia sceno pretas.
    </p>

    <p class="mb-3">
      Mi povas diri ankaŭ kelkajn varmajn vortojn pri miaj kunludantoj je preferanco. 
      Ni aspektas tiel kunfandita ensemblo, ke flanka spektanto povus imagi, ke ni kunvenis por reciprokaj konfesoj pri amikeco, sed ne por gajni monon unu de la aliu.
    </p>

    <p class="mb-1">
      <span class="bold">Raportisto</span>: Kaj konklude, nia tradicia demando. Kiaj estas viaj kreaj planoj?
    </p>

    <p class="mb-1">
      <span class="bold">Aktoro</span>: Mi esperas daŭrigi prilaboradon de roloj el mia klasika repertuaro. 
      Krom tio, mi preparas min al novaj spektakloj. 
      Ekzemple, baldaŭ la spektantaro konatiĝos kun mia nova granda rolo – la rolo de fakestro en la sama teatraĵo, kie mi antaŭe ludis la vic-fakestron.
    </p>

    <p class="mb-3">
      Kaj ekzistas ankaŭ aliaj projektoj. 
      Tamen, por enkarnigi ilin, mi bezonas modernan, konvenan al mi dramverkon; do, mi ne volas anticipi eventojn.
    </p>
    `
  )
}

const itemName = {
  esp: 'La tuta mondo estas teatro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;